import {RETAIL, SUPER_ADMIN, USER} from "../../../helpers/constants";
import ReactTable from "react-table";
import {I18n} from "../../../I18n/components/loan";
import Pagination from "../../Pagination/Pagination";
import React from "react";

const LoanOrderList = props => {
    const loanOrders = props.loanOrders ? props.loanOrders : [];
    const isRetail = props.authority !== SUPER_ADMIN && props.company.types.includes(RETAIL);
    const isUser = props.authority === USER;

    const tableData = loanOrders.map((item) => {
        const product = item.product;
        return {
            id: item.id,
            invoiceNumber: item.invoiceNumber,
            clientPhone: item.clientPhone,
            price: product.sum,
            productName: product.name,
            retailerName: item.retailerName,
            pointName: item.pointName,
            user: item.userName + " / " + item.userPhoneNumber,
            bankName: item.bankName,
            status: item.status.message,
            created: item.created.substring(0, 10),
        };
    });

    return (
        <div className="MyReactTableClass">
            <ReactTable
                getProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px 0"
                        }
                    };
                }}
                getTheadProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                        }
                    };
                }}
                getTrProps={(state, rowInfo, column, instance) => {
                    return {
                        onClick: () => props.onOrderClick(rowInfo.original.id),
                        style: {
                            cursor: "pointer",
                            alignItems: "center"
                        }
                    };
                }}
                getNoDataProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: `№`,
                        accessor: "invoiceNumber",
                        sortable: true,
                        filterable: false,
                        minWidth: 120,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].phoneNumber}`,
                        accessor: "clientPhone",
                        sortable: true,
                        filterable: false,
                        minWidth: 140,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].price}`,
                        accessor: "price",
                        sortable: false,
                        filterable: false,
                        minWidth: 60,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].product}`,
                        accessor: "productName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].company}`,
                        accessor: "retailerName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        show: !isRetail,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].store}`,
                        accessor: "pointName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        show: !(isRetail && isUser),
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].salesman}`,
                        accessor: "user",
                        sortable: false,
                        filterable: false,
                        minWidth: 150,
                        show: !(isRetail && isUser),
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].bank}`,
                        accessor: "bankName",
                        sortable: false,
                        filterable: false,
                        minWidth: 60,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].status}`,
                        accessor: "status",
                        sortable: true,
                        filterable: false,
                        minWidth: 60,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[props.lang].created}`,
                        accessor: "created",
                        sortable: true,
                        filterable: false,
                        minWidth: 110,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                ]}
                manualSorting={true}
                onSortedChange={props.onSortedChange}
                defaultSorted={!props.sort ? [] : [{
                    id: props.sort.id,
                    desc: props.sort.desc,
                }]}
                sort={!props.sort ? [] : [{id: props.sort.id, desc: props.sort.desc}]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                defaultPageSize={-1}
                pageSize={tableData.length}
                showPaginationBottom={props.totalPages > 1}
                className="-highlight"
                data={tableData}
                filterable
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
}

export default LoanOrderList


// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrderList.js